import { GetterTree } from 'vuex';
import { ReplyModel, ReplyInfo } from '@descomplica/dex-models';
import { ReplyState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ReplyState, RootState> = {
  replyById:
    (state, repliesGetters) =>
    (replyId: number): ReplyModel | undefined => {
      const reply = state.replies[replyId.toString()];

      return reply ? new ReplyModel(reply, repliesGetters) : undefined;
    },
  repliesByListUser: (state, repliesGetters) => (listId: number, userId: number) => {
    return Object.values(state.replies)
      .map((reply: ReplyInfo) => new ReplyModel(reply, repliesGetters))
      .filter((reply) => reply.userId === userId && reply.listId === listId);
  },
  repliesByQuestionId: (state, repliesGetters) => (questionId: number) => {
    return Object.values(state.replies)
      .map((reply: ReplyInfo) => new ReplyModel(reply, repliesGetters))
      .filter((reply) => reply.questionId === questionId);
  },
};

export default getters;
